<template>
  <div>
    <template v-if="!noneChildPage">
      <div class="sub-content"></div>

      <div class="airgsm-container mb-5" dir="auto">
        <div class="campaign-container padd-top-0 mobile-relative">
          <nuxt-child />
        </div>
      </div>
    </template>
    <template v-else>
      <nuxt-child />
    </template>
  </div>
</template>

<script>
  export default {
    name: 'Campaign',

    data() {
      return {}
    },

    computed: {
      noneChildPage() {
        return (
          this.getRouteBaseName() === 'campaign-slug' || this.getRouteBaseName() === 'profile-delete-account-success'
        )
      },
    },

    fetch(context) {
      return new Promise((resolve, reject) => {
        context.store.dispatch('fetch_static_content')
        resolve()
      })
    },

    head() {
      return {
        bodyAttrs: {
          class: !this.noneChildPage ? 'sub-page-big-header' : '',
        },
      }
    },

    created() {
      this.$store.commit('set_mobile_header_text', this.$t('components.sub.navigation.title'))
    },

    scrollToTop: true,
  }
</script>
<style scoped>
  @media all and (min-width: 768px) {
    .airgsm-container {
      margin-top: 2rem;
    }
  }
</style>
<style>
  .mobile-profile-sub-header {
    font-size: 1.25rem;
    font-weight: bold;
    margin-bottom: 1.5rem;
  }

  .mobile-profile-sub-header + .row {
    padding-top: 1.5rem;
  }
  @media all and (min-width: 768px) {
    .mobile-profile-sub-header {
      font-size: 1.5rem;
    }

    .mobile-profile-sub-header + .row {
      padding-top: 0;
    }
  }
  @media all and (max-width: 575px) {
    .mobile-profile-sub-header {
      max-width: 90%;
      margin: 0 auto;
      font-size: 1.2rem !important;
    }
  }
</style>
<style>
  .campaign-content > ol > li {
    margin-bottom: 1rem;
  }
  /*.campaign-content > ol > li:not:has(ol) {*/
  /*  font-weight: bold;*/
  /*}*/
  .campaign-content ol {
    counter-reset: first;
  }
  .campaign-content ol ol {
    padding-left: 2rem;
    counter-reset: second;
  }
  .campaign-content ol ol ol {
    counter-reset: third;
  }
  .campaign-content li {
    display: block;
  }
  .campaign-content ol > li:before {
    content: counter(first) '. ';
    counter-increment: first;
  }
  .campaign-content ol > li > ol > li:before {
    content: counter(first) '.' counter(second) '. ';
    counter-increment: second;
  }
  .campaign-content ol > li > ol > li > ol > li:before {
    content: counter(third, lower-alpha) '. ';
    counter-increment: third;
  }

  .campaign-container h1 {
    text-align: center;
    font-size: 1.5rem;
    margin-bottom: 1rem;
    font-weight: bold;
  }
  .campaign-container h2 {
    text-align: center;
    font-size: 1.25rem;
    margin-bottom: 1rem;
    font-weight: bold;
  }
  .campaign-content a {
    text-decoration: underline;
  }
  @media all and (max-width: 1024px) {
    .campaign-content {
      padding-left: calc(1rem + 40px);
      padding-right: calc(1rem + 40px);
    }
  }
  @media all and (max-width: 768px) {
    .campaign-content ol ol {
      padding-left: 1rem;
    }
    .campaign-content {
      padding-left: calc(1rem + 30px);
      padding-right: calc(1rem + 30px);
    }
  }
  @media all and (min-width: 768px) {
    .campaign-container .mobile-profile-sub-header {
      display: none;
    }
  }
  @media all and (max-width: 575px) {
    .campaign-content {
      padding-left: calc(1rem + 20px);
      padding-right: calc(1rem + 20px);
    }
  }
</style>
<style scoped>
  .sub-content {
    width: 100%;
    background: white;
    text-align: center;
    border-bottom: 1px solid #ddd;
  }

  @media only screen and (max-width: 767px) {
    .campaign-container {
      margin-top: -45px !important;
    }

    .more-info-container {
      padding-left: 0;
    }
  }
</style>
